import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderItem, OrderResponse } from "src/common/types/response/orders";

interface OrdersState {
  orders?: Array<OrderItem>;
  loading: boolean;
  page: number;
}
const initialState: OrdersState = {
  orders: [],
  loading: false,
  page: 1,
};

export const orderNotificationsSlice = createSlice({
  name: "orderNotifications",
  initialState,
  reducers: {
    clearData: () => initialState,
    removeOrder: (state, action: PayloadAction<{ id: string }>) => {
      const newOrders = state.orders.filter(
        (it) => it._id !== action.payload.id
      );
      state.orders = newOrders;
    },
    addOrder: (state, action: PayloadAction<OrderItem>) => {
      const present = state.orders.find((it=>it._id === action.payload._id))
      if(present){
        const newOrders = state.orders.map(
          (it) => {
            if(it._id === action.payload._id){
              return action.payload
            }
            return it
          }
        );
        state.orders = newOrders;
      }else{
        state.orders = [...state.orders, action.payload]
      }
    },
  },
});

export const { clearData, removeOrder, addOrder } =
  orderNotificationsSlice.actions;

export default orderNotificationsSlice.reducer;
